import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Matrix from "../containers/Matrix";

import DateRangeSelectorDrawer from "../components/DateRangeSelectorDrawer";
import SiteFilter from "../components/SiteFilter";
import PageCategoryFilter from "../components/PageCategoryFilter";

const runningLocal = process.env.REACT_APP_API_DOMAIN !== "sc";
const PageCategoryService = runningLocal ?
                        require("../data/PageCategoryService.dev").default :
                        require("../data/PageCategoryService.prod").default;


                      
const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    fontSize: "16px",
    textTransform: "none"
  },
  toolbar: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3
  }),
  body: {
    overflowY: 'hidden',
    overflowX: 'hidden'
  }
});

const SelectedStartDate = moment().subtract(30, "days");
const SelectedEndDate = moment();

class InsightsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      site: "all",
      category: null,
      filters: null,
      dateRange: { start: SelectedStartDate, end: SelectedEndDate },
      startDate: SelectedStartDate,
      endDate: SelectedEndDate,
      dateRangeSelectorActive: false
    };
    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleSiteFilterChanged = this.handleSiteFilterChanged.bind(this);
    this.handleCategoryFilterChanged = this.handleCategoryFilterChanged.bind(this);
  }

  componentDidMount() {
    PageCategoryService.getCategories()
      .then(filters => {
        this.setState({
          filters: filters
        })
      })
      .catch(err => console.error(err));
  }

  handleDrawerClose(newDateRange) {
    // console.log("handleDrawerClose");
    // console.log(newDateRange);
    if (newDateRange.start && newDateRange.end) {
      this.setState({
        dateRangeSelectorActive: false,
        dateRange: {
          start: moment(newDateRange.start),
          end: moment(newDateRange.end)
        }
      });
    } else {
      this.setState({
        dateRangeSelectorActive: false
      });
    }
  }

  handleSiteFilterChanged(siteName) {
    if (siteName !== this.state.site) {
      this.setState({
        site: siteName
      });
    }
  }

  handleCategoryFilterChanged(category) {
    if (category !== this.state.category) {
      this.setState({
        category: category
      });
    }
  }

  render() {
    const { dateRange, site } = this.state;
    const { classes, children, showSiteFilter, showCategoryFilter } = this.props;
    const childProps = { ...this.state };

    return (
      <Grid container className={classes.root} spacing={16}>
        <Grid item xs={12}>
          <Grid container className={classes.demo} spacing={32}>
            <Grid item>
              <Button
                className={classes.button}
                onClick={() => this.setState({ dateRangeSelectorActive: true })}
              >
                {this.state.dateRange.start.format("MMMM Do, YYYY")} -{" "}
                {this.state.dateRange.end.format("MMMM Do, YYYY")}
              </Button>
            </Grid>
            {showSiteFilter ?
              <Grid item>
                <SiteFilter onFilterChanged={this.handleSiteFilterChanged} />
              </Grid> : null}
            {this.state.filters && showCategoryFilter ?
              <Grid item>
                <PageCategoryFilter filters={this.state.filters} onFilterChanged={this.handleCategoryFilterChanged} />
              </Grid> : null}
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.body}>
          <Grid container className={classes.demo} spacing={32}>
            {React.Children.map(children, child =>
              React.cloneElement(child, childProps))}

            <DateRangeSelectorDrawer
              isOpen={this.state.dateRangeSelectorActive}
              dateRange={dateRange}
              closeDrawer={this.handleDrawerClose}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

InsightsPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(InsightsPage);



// WEBPACK FOOTER //
// ./src/containers/InsightsPage.js